import { Injectable } from '@angular/core';
import { Observable, EMPTY, of,  tap } from 'rxjs';
import { HttpClient, HttpParams } from "@angular/common/http";
import { OrganizationContact } from '@models/organizationContact.model';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContactDetailsService {
  private apiUrl = environment.apiUrl;

  createOrganizationContact(details: any): Observable<any> {
    return this.http.post<OrganizationContact>(`${this.apiUrl}/Organization/Contact`, details);
  }

  updateOrganizationContact(details: any): Observable<any> {
    return this.http.put<OrganizationContact>(`${this.apiUrl}/Organization/Contact`, details);
  }

  deleteOrganizationContact(id: any): Observable<any> {
    return this.http.delete<OrganizationContact>(`${this.apiUrl}/Organization/Contact/${id}`);
  }
  constructor(private http: HttpClient) { }
}
